const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.875 1.71125L14.2887 0.125L8 6.41375L1.71125 0.125L0.125 1.71125L6.41375 8L0.125 14.2887L1.71125 15.875L8 9.58625L14.2887 15.875L15.875 14.2887L9.58625 8L15.875 1.71125Z"
      fill="white"
    />
  </svg>
);

export default CloseIcon;
